import React from 'react';

interface HeaderProps {
  title?: string;
  subtitle?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  title = "AI Question Explorer", 
  subtitle = "Dive deep into any topic with AI-powered follow-up questions" 
}) => {
  return (
    <header className="modern-header compact">
      <div className="header-background">
        <div className="floating-particles">
          {[...Array(4)].map((_, i) => (
            <div key={i} className={`particle particle-${i + 1}`}></div>
          ))}
        </div>
        <div className="gradient-orbs">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
        </div>
      </div>
      
      <div className="header-content">
        <div className="header-icon">
          <div className="icon-container">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path 
                d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" 
                fill="currentColor"
                className="star-main"
              />
              <path 
                d="M19 15L20.09 18.26L24 19L20.09 19.74L19 23L17.91 19.74L14 19L17.91 18.26L19 15Z" 
                fill="currentColor"
                className="star-small"
              />
              <path 
                d="M5 6L5.5 7.5L7 8L5.5 8.5L5 10L4.5 8.5L3 8L4.5 7.5L5 6Z" 
                fill="currentColor"
                className="star-tiny"
              />
            </svg>
          </div>
        </div>
        
        <div className="header-text">
          <h1 className="modern-header-title compact">
            <span className="title-word">{title.split(' ')[0]}</span>
            <span className="title-word">{title.split(' ')[1]}</span>
            <span className="title-word highlight">{title.split(' ')[2]}</span>
          </h1>
          {subtitle && (
            <p className="modern-header-subtitle compact">
              <span className="subtitle-text">{subtitle}</span>
              <div className="subtitle-underline"></div>
            </p>
          )}
        </div>
        
        <div className="header-stats compact">
          <div className="stat-item">
            <div className="stat-number">∞</div>
            <div className="stat-label">Questions</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">10</div>
            <div className="stat-label">Perspectives</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">AI</div>
            <div className="stat-label">Powered</div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 